<template>
  <div v-show="showModal" ref="commentModal">
    <hi-dialog class="caption-dialog" :title="title" @close="closeDialog">
      <hi-button
        class="edit-btn"
        :disabled="editDisabled"
        type="text"
        slot="left"
        v-show="!edit && tabIndex !== 2"
        @click.native="editClick"
        >Edit
      </hi-button>
      <hi-button
        class="edit-btn"
        type="text"
        slot="left"
        v-show="edit && tabIndex !== 2"
        @click.native="cancelClick"
      >
        Cancel
      </hi-button>
      <div v-show="!edit" class="top-comment-container">
        <hi-text-area
          v-if="twitter"
          placeholder="write first reply..."
          v-model="form.firstComment"
          socialNetwork="twitter"
          style="width: 100%; height: 160px"
          :max="280"
          ref="textarea"
        ></hi-text-area>
        <hi-text-area
          v-else
          placeholder="write a comment..."
          v-model="form.firstComment"
          style="width: 100%; height: 160px"
          :max="max"
          :filterNum="filterNum"
          filterText="#"
          ref="textarea"
        ></hi-text-area>
      </div>
      <div class="main-container">
        <hi-tab
          :edit="edit"
          v-model="tabIndex"
          :tabList="tabList"
          class="tab-container"
        ></hi-tab>
        <div v-show="tabIndex === 0" class="history-page">
          <calender-caption
            :edit="edit"
            :key="history.id"
            @click="commentItemClick"
            :model="history"
            v-for="history in commentHistories"
          ></calender-caption>
          <div v-if="commentHistories.length === 0" class="no-list">
            {{ noHistoryText }}
          </div>
        </div>
        <div v-show="tabIndex === 1" class="tag-page">
          <div class="tags-container">
            <calender-caption
              :edit="edit"
              :key="tag.id"
              @click="commentItemClick"
              :model="tag"
              v-for="tag in commentTags"
            ></calender-caption>
            <div v-if="commentTags.length === 0" class="no-list">
              {{ noSavedText }}
            </div>
          </div>
          <div v-show="!edit" class="bottom-container">
            <div class="save-text-container">
              <form-text-area-component
                v-if="twitter"
                socialNetwork="twitter"
                :max="280"
                placeholder="Add Hashtags & Caption"
                v-model="addTagText"
              >
              </form-text-area-component>
              <form-text-area-component
                v-else
                placeholder="Add Hashtags & Caption"
                v-model="addTagText"
              >
              </form-text-area-component>
            </div>
            <button class="save-btn" @click="saveTag">Save</button>
          </div>
        </div>
        <suggested
          v-show="tabIndex === 2"
          @itemClick="commentItemClick"
        ></suggested>
        <div v-show="edit" class="del-bottom-container">
          <hi-button class="btn" type="text" @click.native="allClick"
            >Select All</hi-button
          >
          <hi-button
            class="btn"
            type="text"
            :disabled="delDisabled"
            @click.native="delClick"
            >Delete</hi-button
          >
        </div>
      </div>
      <div class="bulk-bottom-container" v-show="only">
        <hi-button class="bulk-save-btn" @click.native="saveClick"
          >Done</hi-button
        >
      </div>
    </hi-dialog>
  </div>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";

.caption-dialog {
  width: 375px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  height: 730px;
  background: #f5f6f7;

  .no-list {
    display: flex;
    font-size: 16px;
    color: gray;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  .edit-btn {
    padding: 0;
  }

  .top-comment-container {
    padding: 20px;
    border-bottom: 1px solid #e5e5e5;
    background: white;
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    background: white;

    textarea {
      border: 0;
      font-size: 14px;
    }

    .tab-container {
      padding: 0 20px;
      border-bottom: 1px solid #e6e6e6;
    }

    .tag-page {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;

      .tags-container {
        flex: 1;
        overflow: auto;
      }

      .bottom-container {
        text-align: center;
        background: white;
        border-top: 1px solid #d2d2d2;
        padding: 15px;

        .save-text-container {
          font-size: 14px;
          border-radius: 3px;
          border: 1px solid #d2d2d2;
          background: #f5f5f5;
          width: 100%;
          box-sizing: border-box;
          padding: 12px 12px 3px 12px;
        }

        .save-btn {
          color: @color-primary;
          font-size: 14px;
          border: 1px solid #e5e5e5;
          border-radius: 3px;
          height: 40px;
          padding: 0 14px;
          width: 100%;
          cursor: pointer;
          -webkit-appearance: button;
          background: white;
          margin-top: 10px;
        }
      }
    }

    .del-bottom-container {
      border-top: 1px solid #d2d2d2;
      padding: 0 20px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn {
        font-size: 16px;
        padding: 0;
      }
    }

    .history-page {
      overflow: auto;
      flex: 1;
    }
  }

  .bulk-bottom-container {
    height: 64px;
    border-top: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: white;
    padding: 0 20px;

    .bulk-save-btn {
      width: 98px;
      height: 36px;
    }
  }
}
</style>

<script>
import hiDialog from "../../../common/dialog/Index.vue";
import hiTab from "../../../common/tab/Tab";
import hiTextArea from "../../../common/form/TextArea.vue";
import calenderCaption from "../../../calender/caption/Index.vue";
import suggested from "../../../media/schedule/suggested/Suggested";
import hiButton from "../../../common/button/Index";
import FormTextAreaComponent from "../../../common/form/TextArea";
import { showErrorMsg } from "../../../../utils/errors";
import {
  createUserContent,
  delUserContent,
  getUserContent,
  permissionValidate,
} from "../../../../service/publisher";
import {
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
} from "../../../../store/mutation-types";
import store from "../../../../store/index";
import { mapGetters } from "vuex";
export default {
  name: "CalenderScheduleCommentComponent",
  components: {
    hiTextArea,
    hiDialog,
    hiTab,
    calenderCaption,
    hiButton,
    suggested,
    FormTextAreaComponent,
  },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    form: {
      //  表单
      type: Object,
      default: () => {
        return {
          firstComment: "",
        };
      },
    },
    type: {
      // add 只是单独用于添加comment所需
      type: String,
      default: "form",
    },
    publisherId: {
      default: () => {
        // 如果设置了publisherId则读取设置 否则默认是当前
        return store.getters[CURRENT_PUBLISHER_SIMPLE].publisherId;
      },
    },
  },
  data() {
    return {
      edit: false, // 是否开启编辑模式
      showModal: this.show,
      addTagText: "",
      tabIndex: 0,
      commentHistories: [],
      commentTags: [],
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    noHistoryText() {
      if (this.twitter) {
        return "No reply history here";
      } else {
        return "No comment history here";
      }
    },
    noSavedText() {
      if (this.twitter) {
        return "No saved reply here";
      } else {
        return "No saved comment here";
      }
    },
    tabList() {
      if (this.twitter) {
        return [{ title: "History" }, { title: "Saved" }];
      } else {
        return [
          { title: "History" },
          { title: "Saved" },
          { title: "Suggested #" },
        ];
      }
    },
    // 获取当前操作表单用户的publisher
    publisher() {
      return this.user.linkedInstagramList.find(
        (i) => i.publisherId === this.publisherId
      );
    },
    twitter() {
      return this.publisher.socialNetwork === 4;
    },
    title() {
      if (this.twitter) {
        return "Add First Reply";
      } else {
        return "Add First Comment";
      }
    },
    max() {
      return this.$parent.max;
    },
    filterNum() {
      if (this.type === "add") {
        const firstComment = this.info.form.firstComment || "";
        const text = firstComment;
        const find = [...text].filter((v) => {
          return v === "#";
        });
        return find.length;
      } else {
        return this.$parent.filterNum;
      }
    },
    only() {
      return !this.$parent.showMainFormModal;
    },
    /**
     * 数量不足不可编辑
     */
    editDisabled() {
      return this.commentHistories.length + this.commentTags.length === 0;
    },
    /**
     * 如果一项都未选中则无法删除
     */
    delDisabled() {
      // 当前选项是否至少存在一项
      if (this.tabIndex === 0) {
        const select = this.commentHistories.find((c) => c.select);
        return select === undefined;
      } else {
        const select = this.commentTags.find((c) => c.select);
        return select === undefined;
      }
    },
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.publisher.permissions;
    },
    /**
     * first comment权限
     */
    firstCommentPermission() {
      return this.permission.first_comment;
    },
  },
  methods: {
    /**
     * bulk模式下显示done按钮点击事件
     */
    async saveClick() {
      if (!this.firstCommentPermission) {
        await permissionValidate({ type: "full" });
        return;
      }
      // 先验证用户是否有common权限
      await this.$parent.showCommentDialog();
      this.$parent.info.form.firstComment = this.form.firstComment;
      this.showModal = false;
    },
    /**
     * 更新caption信息
     */
    async updateCommentList() {
      // 获取当前指定publisher的comment
      const list = await getUserContent({
        type: "comment",
        publisherId: this.publisherId,
      });
      list.forEach((l) => {
        l.text = l.content;
        l.date = l.date_created;
        l.select = false;
      });
      this.commentHistories = list.filter((comment) => comment.is_history);
      this.commentTags = list.filter((comment) => comment.is_saved);
    },
    /**
     * 选中所有点击事件
     */
    allClick() {
      // 选中history
      if (this.tabIndex === 0) {
        this.commentHistories.forEach((c) => {
          c.select = true;
        });
      } else {
        this.commentTags.forEach((c) => {
          c.select = true;
        });
      }
    },
    /**
     * 删除选中项点击事件
     */
    async delClick() {
      const loading = this.$loading({ target: this.$refs.commentModal });
      try {
        let delIds = [];
        // 选中history
        if (this.tabIndex === 0) {
          delIds = this.commentHistories
            .filter((c) => c.select === true)
            .map((d) => d.id);
        } else {
          delIds = this.commentTags
            .filter((c) => c.select === true)
            .map((d) => d.id);
        }
        await delUserContent({ publisherId: this.publisherId, ids: delIds });
        // 取消编辑模式
        this.edit = false;
        // 更新caption数据
        this.updateCommentList();
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 编辑按钮点击事件
     */
    editClick() {
      this.edit = true;
    },
    /**
     * 取消按钮点击事件
     */
    cancelClick() {
      this.edit = false;
    },
    // tag被点击回调
    commentItemClick(item) {
      if (this.edit) {
        // 如果处于编辑状态,则点击则进行勾选
        item.select = !item.select;
      } else {
        this.$refs.textarea.addText(item.text);
      }
    },
    // 添加tag
    async saveTag() {
      if (this.addTagText) {
        const loading = this.$loading({ target: this.$refs.commentModal });
        try {
          const form = {
            content_type: 2,
            content: this.addTagText,
            is_saved: true,
            is_history: false,
          };
          await createUserContent({ publisherId: this.publisherId, form });
          this.edit = false;
          this.updateCommentList();
          this.addTagText = "";
        } catch (e) {
          showErrorMsg(e);
        } finally {
          loading.close();
        }
      }
    },
    /**
     * 关闭dialog点击事件
     */
    async closeDialog() {
      this.showModal = false;
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.tabIndex = 0;
        this.addTagText = "";
      } else {
        if (this.only) {
          this.$parent.close();
        }
      }
      this.$emit("updateShow", val);
    },
    show(val) {
      this.showModal = val;
    },
    async publisherId(val) {
      // 获取当前指定publisher的comment
      await this.updateCommentList();
    },
  },
  async created() {
    const loading = this.$loading({ target: this.$refs.commentModal });
    try {
      // 获取当前指定publisher的comment
      await this.updateCommentList();
    } catch (e) {
      showErrorMsg(e);
    } finally {
      loading.close();
    }
  },
};
</script>
